import { render, staticRenderFns } from "./popup-card.vue?vue&type=template&id=a6be3156&scoped=true"
import script from "./popup-card.vue?vue&type=script&lang=ts"
export * from "./popup-card.vue?vue&type=script&lang=ts"
import style0 from "./popup-card.vue?vue&type=style&index=0&id=a6be3156&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6be3156",
  null
  
)

export default component.exports